import React, { useState, useEffect } from 'react'
import { css, style } from 'glamor';
import * as styles from './articlelistpagenew.style';
import './articleListPageNew.css';
import HeaderTabletSection from '../common/header/header.tablet'
import HeaderSection from '../common/header/header'
import Search from '../search/search';
import NavBar from '../../components/navbar/navbar';
import * as navData from '../../configs/navigation';
import * as navigation from '../../configs/navigation';
import FooterSection from '../common/footer/footer';
import SideFilters from './SideFilters';
import httpProvider from '../../services/httpProvider.service';
import ArticleListPagination from './ArticleListPagination';
import * as translate from '../../assets/translations/translations';
import TagsData from './jsonData/Tags.json';
import AnalystsData from './jsonData/Analysts.json';
import ArticleMainList from './ArticleMainList';

const ArticleListPageNew = (props) => {
    const [showSearch, setshowSearch] = useState("");
    const [categoryData, setCategoryData] = useState([]);
    const [tempSearchText, setTempSearchText] = useState("");
    const [searchType, setSearchType] = useState("");
    const [actualSearchText, setActualSearchText] = useState("");
    const [sortByRelevanceDate, setSortByRelevanceDate] = useState("");
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [showFilterItems, setFilterItems] = useState({});
    const [periodSelectedVal, setPeriodSelectedVal] = useState();
    const [periodSelectedDates, setPeriodSelectedDates] = useState();
    const [typesSelectedVal, setTypesSelectedVal] = useState();
    const [languagesSelectedVal, setLanguagesSelectedVal] = useState();
    const [analystSelectedVal, setAnalystSelectedVal] = useState({ optionAnalystSelected: null });
    const [categoriesSelectedVal, setCategoriesSelectedVal] = useState();
    const [companyListSelectedVal, setCompanyListSelectedVal] = useState();
    const [tagsSelectedVal, setTagsSelectedVal] = useState({ optionTagsSelected: null });
    const [currSiteLang, setCurrSiteLang] = useState();
    const [userAccessAccept, setUserAccessAccept] = useState();
    const [articlesData, setArticlesData] = useState([]);
    const [currUrlSearch, setCurrUrlSearch] = useState("");
    const [commissionedResearchDesc, setCommissionedResearchDesc] = useState("");
    const [hasMoreFinite, setHasMoreFinite] = useState(true);
    const [indexFinite, setIndexFinite] = useState(2);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [OffsetPage, setOffsetPage] = useState(0);
    const [uncheckedAll, setUncheckedAll] = useState(false);
    const [dateFilter, setDateFilter] = useState([
        {
            startDate: null,
            endDate: null,
            key: 'selection'
        }
    ]);
    const existingSearchParamsPage = JSON.parse(sessionStorage.getItem('searchParams'))


    useEffect(() => {
        const requestURL = `${window.ServerUrl}/research-categories`
        httpProvider.get(requestURL).then((res) => {
            if (res.data) {
                setCategoryData(res.data);
            }
        }).catch((err) => {
            console.log(err);
            setCategoryData([]);
        })
    }, [])

    useEffect(() => {
        const company = translate.companyDescriptions.find(c => c.company == props?.match?.params?.search)
        setCommissionedResearchDesc(company?.description)
    }, [props.match.params.searchByLatest]);

    useEffect(() => {
        let agreementAccepted = localStorage.getItem('agreementAccepted') == 'true' || false;
        const userAccess = (agreementAccepted == true) ? 'unrestricted' : 'restricted';
        setUserAccessAccept(userAccess)
        setCurrSiteLang(localStorage.getItem('language') || 'EN')
    }, [])

    useEffect(() => {
        const existingSearchParams = JSON.parse(sessionStorage.getItem('searchParams'))
        if (existingSearchParams) {
            setFilterItems(existingSearchParams)
            setPeriodSelectedVal(existingSearchParams?.periodSelectedVal)
            if (existingSearchParams?.period == "Date range") {

                setDateFilter([
                    {
                        startDate: existingSearchParams?.publicationDate.fromDate ? new Date(existingSearchParams?.publicationDate.fromDate) : null,
                        endDate: existingSearchParams?.publicationDate.toDate ? new Date(existingSearchParams?.publicationDate.toDate) : null,
                        key: 'selection'
                    }
                ])
            }
            setSearchType(existingSearchParams?.searchType)
            setTypesSelectedVal(existingSearchParams?.types)
            setLanguagesSelectedVal(existingSearchParams?.languages)
            setAnalystSelectedVal({
                optionAnalystSelected: existingSearchParams?.analysts_original
            })

            if (props.match.params.searchByLatest == "commr") {
                if (existingSearchParams?.companyList?.length > 1) {
                    if (!existingSearchParams?.uncheckedAll) {
                        setCompanyListSelectedVal([
                            ...(existingSearchParams?.companyList || []),
                            props?.match?.params?.search
                        ]);
                    }
                    setFilterItems({
                        ...existingSearchParams,
                        companyList: Array.from(
                            new Set([
                                ...(existingSearchParams?.companyList || []),
                                props?.match?.params?.search
                            ])
                        )
                    });
                } else {
                    setFilterItems(prev => ({
                        ...prev, "companyList": Array.from(
                            new Set([
                                ...(existingSearchParams?.companyList || []),
                                props?.match?.params?.search
                            ])
                        )
                    }));

                    setCompanyListSelectedVal([props?.match?.params?.search])
                }
            } else {
                setCategoriesSelectedVal(existingSearchParams?.categories)
            }

            setTagsSelectedVal({
                optionTagsSelected: existingSearchParams?.tags_original
            })
            setSortByRelevanceDate(existingSearchParams?.sortBy)
            if (existingSearchParams?.period == "Date range") {
                setShowDatePicker(true)
            }
        } else {
            console.log("TITLE")
            setSearchType("title")
            setSortByRelevanceDate("Relevance")
            if (props.match.params.searchByLatest == "commr") {
                setFilterItems(prev => ({
                    ...prev, "companyList": Array.from(
                        new Set([
                            ...(existingSearchParams?.companyList || []),
                            props?.match?.params?.search
                        ])
                    )
                }));

                setCompanyListSelectedVal([props?.match?.params?.search])
            }
        }
    }, [])

    useEffect(() => {
        if (props?.match?.params?.searchByLatest != "commr") {
            setActualSearchText(tempSearchText)
        }
    }, [tempSearchText])

    useEffect(() => {
        if (userAccessAccept && props?.match?.params?.search) {
            const requestParams = {
                // "offset": 0,
                // "limit": 10,
                // "access": userAccessAccept,
                // "option": props?.match?.params?.searchByLatest == "commr" ? "subcategory" : "wildcard", //commr => update subcategory
                // "search": props?.match?.params?.searchByLatest == "commr" ? showFilterItems?.companyList?.length > 0 ? showFilterItems?.companyList?.join(", ") : tempSearchText : tempSearchText,
                // //"sortBy": (showFilterItems?.sortBy == undefined || showFilterItems?.sortBy == "") ? "Relevance" : showFilterItems?.sortBy,
                // "searchByLatest": true,
                "publicationDate": (showFilterItems?.publicationDate == undefined || showFilterItems?.publicationDate == "") ? [] : showFilterItems?.publicationDate,
                "types": (showFilterItems?.types == undefined || showFilterItems?.types == "") ? [] : showFilterItems?.types,
                "languages": (showFilterItems?.languages == undefined || showFilterItems?.languages == "") ? [] : showFilterItems?.languages,
                "analysts": (showFilterItems?.analysts_original == undefined || showFilterItems?.analysts_original == "") ? [] : showFilterItems?.analysts_original?.filter(item => item?.fullName).map(item => item?.fullName),
                "categories": (showFilterItems?.categories == undefined || showFilterItems?.categories == "") ? [] : showFilterItems?.categories,
                // "companyList": (showFilterItems?.companyList == undefined || showFilterItems?.companyList == "") ? [] : showFilterItems?.companyList,
                "tags": (showFilterItems?.tags_original == undefined || showFilterItems?.tags_original == "") ? [] : showFilterItems?.tags_original?.filter(item => item?.keyword).map(item => item?.keyword),
                "searchType": showFilterItems?.searchType ? showFilterItems?.searchType : "title",
                // "uncheckedAll": showFilterItems?.uncheckedAll == undefined ? false : showFilterItems?.uncheckedAll
            }

            const SessionData = { ...requestParams };
            SessionData.search = props?.match?.params?.searchByLatest == "commr" ? showFilterItems?.companyList?.length > 0 ? showFilterItems?.companyList?.join(", ") : tempSearchText : tempSearchText, //added temporarily for search changes
                SessionData.periodSelectedVal = periodSelectedVal
            SessionData.period = periodSelectedVal
            SessionData.analysts_original = showFilterItems?.analysts_original
            SessionData.tags_original = showFilterItems?.tags_original
            SessionData.uncheckedAll = showFilterItems?.uncheckedAll == undefined ? false : showFilterItems?.uncheckedAll
            sessionStorage.setItem('searchParams', JSON.stringify(SessionData))

            const requestParamsFinal = { ...requestParams };
            requestParamsFinal.analysts = (showFilterItems?.analysts_original == undefined || showFilterItems?.analysts_original == "") ? [] : showFilterItems?.analysts_original?.map(item => item?.fullName)
            requestParamsFinal.tags = (showFilterItems?.tags_original == undefined || showFilterItems?.tags_original == "") ? [] : showFilterItems?.tags_original?.filter(item => item?.keyword).map(item => item?.keyword)
            requestParamsFinal.categories = props?.match?.params?.searchByLatest == "commr" ? [] : (showFilterItems?.categories == undefined || showFilterItems?.categories == "") ? [] : showFilterItems?.categories
            // requestParamsFinal.companyList = props?.match?.params?.searchByLatest == "commr" ? (showFilterItems?.companyList == undefined || showFilterItems?.companyList == "") ? [] : showFilterItems?.companyList : []
            let staticUrl = `searchFilters/0/10/${userAccessAccept}/wildcard/${props?.match?.params?.search}/true`;
            httpProvider.post(staticUrl, requestParamsFinal)
                .then((res) => {
                    res?.data?.count >= 10 ? setHasMoreFinite(true) : setHasMoreFinite(false)
                    setArticlesData(res?.data)
                    setItemsPerPage(10)
                    setOffsetPage(0)
                }).catch((err) => {
                    console.log(err);
                    setHasMoreFinite(false)
                    setArticlesData({ count: 0, articles: [] })
                })

        }
    }, [showFilterItems, userAccessAccept, props.match.params.search])

    const handleSearch = (searchitem = false) => {
        if (articlesData?.count > 10) {

            let apiUrl = '';
            let itemPerPageTemp = itemsPerPage + 10;
            let offsetItem = OffsetPage + 10;

            if (props?.match?.params?.searchByLatest == "commr") {
                // apiUrl = `research/${offsetItem}/10/${userAccessAccept}/subcategory/${props?.match?.params?.search}/false`
                setCurrUrlSearch("commr")
            } else {
                // apiUrl = `research/${offsetItem}/10/${userAccessAccept}/wildcard/${props?.match?.params?.search}/false`
                setCurrUrlSearch("searchByLatest")
            }
            let requestParameter = {
                // "offset": offsetItem,
                // "limit": 10,
                // "access": userAccessAccept,
                // "option": props?.match?.params?.searchByLatest == "commr" ? "subcategory" : "wildcard", //commr => update subcategory
                // "search": tempSearchText,
                // //"sortBy": (showFilterItems?.sortBy == undefined || showFilterItems?.sortBy == "") ? "Relevance" : showFilterItems?.sortBy,
                // "searchByLatest": true,
                "publicationDate": (showFilterItems?.publicationDate == undefined || showFilterItems?.publicationDate == "") ? [] : showFilterItems?.publicationDate,
                "types": (showFilterItems?.types == undefined || showFilterItems?.types == "") ? [] : showFilterItems?.types,
                "languages": (showFilterItems?.languages == undefined || showFilterItems?.languages == "") ? [] : showFilterItems?.languages,
                "analysts": (showFilterItems?.analysts_original == undefined || showFilterItems?.analysts_original == "") ? [] : showFilterItems?.analysts_original?.filter(item => item?.fullName).map(item => item?.fullName),
                "categories": props?.match?.params?.searchByLatest == "commr" ? [] : (showFilterItems?.categories == undefined || showFilterItems?.categories == "") ? [] : showFilterItems?.categories,
                // "companyList": props?.match?.params?.searchByLatest == "commr" ? (showFilterItems?.companyList == undefined || showFilterItems?.companyList == "") ? [] : showFilterItems?.companyList : [],
                "tags": (showFilterItems?.tags_original == undefined || showFilterItems?.tags_original == "") ? [] : showFilterItems?.tags_original?.filter(item => item?.keyword).map(item => item?.keyword),
                "searchType": showFilterItems?.searchType ? showFilterItems?.searchType : "title",
                // "uncheckedAll": showFilterItems?.uncheckedAll == undefined ? false : showFilterItems?.uncheckedAll
            }
            setOffsetPage(offsetItem)
            let staticUrl = `searchFilters/${offsetItem}/10/${userAccessAccept}/wildcard/${props?.match?.params?.search}/true`;
            httpProvider.post(staticUrl, requestParameter)
                .then((res) => {
                    setArticlesData((prevItems) => {
                        return {
                            ...res.data,
                            articles: [...prevItems.articles, ...res.data.articles]
                        }
                    });
                    (res?.data?.count > 0 && offsetItem <= res?.data?.count) ? setHasMoreFinite(true) : setHasMoreFinite(false);
                }).catch((err) => {
                    console.log(err);
                    setHasMoreFinite(false)
                    setArticlesData({ count: 0, articles: [] })
                })
            setIndexFinite((prevIndex) => prevIndex + 1);
        }
    }

    const setRelevanceDateSort = (e) => {
        setSortByRelevanceDate(e?.target?.value)
        setFilterItems(prev => ({ ...prev, "sortBy": e?.target?.value }));
    }

    const handleClearAllFilters = () => {
        const existingSearchParams = JSON.parse(sessionStorage.getItem('searchParams'))
        setFilterItems({ searchType: existingSearchParams?.searchType || "title" });
        setPeriodSelectedVal("")
        setLanguagesSelectedVal([])
        setDateFilter([
            {
                startDate: null,
                endDate: null,
                key: 'selection'
            }
        ])
        setTypesSelectedVal([])
        setAnalystSelectedVal({
            optionAnalystSelected: []
        })
        setCategoriesSelectedVal([])
        setCompanyListSelectedVal([])
        if (props?.match?.params?.searchByLatest == "commr") {

            setFilterItems((prev) => ({ "companyList": Array.from(new Set(navData?.companyList?.map(item => item?.text))), "uncheckedAll": true }))
            setUncheckedAll(true)
        }
        setTagsSelectedVal({
            optionTagsSelected: []
        })
        setShowDatePicker(false)
        setSortByRelevanceDate("Relevance")
    }

    const formatNumberWithDot = (number) => {
        if (number) {
            return number?.toLocaleString('de-DE');
        } else {
            return number
        }
    }

    const isAnyFilterSelected = () => {
        return (
            showFilterItems?.periodSelectedVal ||
            showFilterItems?.types?.length > 0 ||
            showFilterItems?.languages?.length > 0 ||
            showFilterItems?.analysts_original?.length > 0 ||
            showFilterItems?.categories?.length > 0 ||
            showFilterItems?.companyList?.length > 0 ||
            showFilterItems?.tags_original?.length > 0 ||
            showFilterItems?.period?.length > 0
        );
    };

    return (
        <>
            <HeaderTabletSection history={props.history} hideNav={false} />
            <HeaderSection showSearch={false} showSearchButton={false} history={""} />
            {props.match.params.searchByLatest == "commr" ? <NavBar items={navigation.commrNavInfo} commr={true} /> : <NavBar items={navigation.navInfo} />}
            {
                props.match.params.searchByLatest != "commr" &&
                <Search homepage={false} searchkey={props.match.params.search} searchByLatest={props.match.params.searchByLatest ? true : false} setTempSearchText={setTempSearchText} showFilterItems={showFilterItems} setFilterItems={setFilterItems} setSearchType={setSearchType} searchType={searchType} />
            }
            <div {...css(styles.mainContainer)} style={{ marginTop: props.match.params.searchByLatest == "commr" ? '100px' : '0px' }}>

                <div className='container-fluid' style={{ marginTop: '50px' }}>
                    <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ml-5'>
                        <div className='row'>
                            <div className="col-md-3 col-lg-3 col-sm-12 col-xl-3 adjustFilter" style={{ marginTop: '18px' }}>
                                <div style={{ paddingTop: '5px', paddingBottom: '16px' }}>
                                    <span style={{ fontSize: '18px', fontWeight: '600', marginLeft: '30px' }}>Filter by</span>
                                    {isAnyFilterSelected() && (
                                        <span className='float-right' style={{ fontSize: '14px', fontWeight: '400', color: '#007BC7', cursor: 'pointer', marginRight: '25px' }} onClick={() => handleClearAllFilters()}>
                                            Clear all
                                        </span>
                                    )}
                                </div>
                                <hr style={{ border: 'none', borderTop: '1px solid #DFEEF4', width: '300px', backdroundColor: '#DFEEF4', }}></hr>
                                <div style={{ paddingLeft: '20px' }}>
                                    <SideFilters
                                        showFilterItems={showFilterItems}
                                        setFilterItems={setFilterItems}
                                        periodSelectedVal={periodSelectedVal}
                                        setPeriodSelectedVal={setPeriodSelectedVal}
                                        setPeriodSelectedDates={setPeriodSelectedDates}
                                        dateFilter={dateFilter}
                                        setDateFilter={setDateFilter}
                                        typesSelectedVal={typesSelectedVal}
                                        setTypesSelectedVal={setTypesSelectedVal}
                                        languagesSelectedVal={languagesSelectedVal}
                                        setLanguagesSelectedVal={setLanguagesSelectedVal}
                                        analystSelectedVal={analystSelectedVal}
                                        setAnalystSelectedVal={setAnalystSelectedVal}
                                        categoriesSelectedVal={categoriesSelectedVal}
                                        setCategoriesSelectedVal={setCategoriesSelectedVal}
                                        tagsSelectedVal={tagsSelectedVal}
                                        setTagsSelectedVal={setTagsSelectedVal}
                                        companyListSelectedVal={companyListSelectedVal}
                                        setCompanyListSelectedVal={setCompanyListSelectedVal}
                                        urlParams={props?.match?.params?.searchByLatest}
                                        TagsData={TagsData}
                                        AnalystsData={AnalystsData}
                                        showDatePicker={showDatePicker}
                                        setShowDatePicker={setShowDatePicker}
                                        showDatepickerDateRange={showFilterItems?.period == "Date range" ? true : false}
                                        uncheckedAll={uncheckedAll}
                                        setUncheckedAll={setUncheckedAll}
                                        categoryData={categoryData}
                                    />
                                </div>
                            </div>
                            <div className='col-md-9 col-lg-9 col-sm-12 col-xl-9' >
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginLeft: '50px', marginRight: '50px', marginTop: articlesData?.count > 0 ? '0px' : '25px' }}>
                                    {(() => {
                                        if (props?.match?.params?.searchByLatest == "commr") {
                                            if (showFilterItems?.companyList?.length > 0 && showFilterItems?.companyList?.length == 14) {
                                                return (
                                                    <span>Viewing {formatNumberWithDot(articlesData?.count)} results for<b style={{ fontWeight: '900' }}> All Companies</b></span>
                                                )

                                            } else {
                                                return (
                                                    <span>Viewing {formatNumberWithDot(articlesData?.count)} results for<b style={{ fontWeight: '900' }}> {showFilterItems?.companyList?.join(", ")}</b></span>
                                                )
                                            }
                                        } else {
                                            return (
                                                <span>Viewing {formatNumberWithDot(articlesData?.count)} results for "<b style={{ fontWeight: '900' }}>{props?.match?.params?.search}</b>"</span>
                                            )
                                            // if (existingSearchParamsPage?.search == "") {
                                            //     return (
                                            //         <span>Viewing <b style={{ fontWeight: '900' }}>{formatNumberWithDot(articlesData?.count)} results</b></span>
                                            //     )
                                            // } else {
                                            //     return (
                                            //         <span>Viewing {formatNumberWithDot(articlesData?.count)} results for "<b style={{ fontWeight: '900' }}>{existingSearchParamsPage?.search}</b>"</span>
                                            //     )
                                            // }

                                        }

                                    })()}
                                    {/* <span>Viewing <b>{articlesData?.count} results</b> for <b>"
                                        {props?.match?.params?.searchByLatest == "commr" ?
                                            showFilterItems?.companyList?.length > 0 ? (showFilterItems?.companyList?.length == 14) ? "All Companies" : showFilterItems?.companyList?.join(", ") :
                                                props?.match?.params?.search : props?.match?.params?.search
                                        }
                                        "</b></span> */}

                                    {
                                        articlesData?.count > 0 &&
                                        <span style={{ display: 'block', fontSize: '14px', fontWeight: '600', marginTop: '57px' /*added margin top for hiding dropdown alone*/ }}>
                                            <span style={{ display: 'block', marginTop: '5px', width: '100%' }}></span>
                                            {/* <label htmlFor='SortBy'>Sort by</label>
                                            <select className='form-control custom-select form-select' id='SortBy' style={{ display: 'block', marginTop: '5px', width: '100%' }} onChange={(e) => setRelevanceDateSort(e)}>
                                                <option value={`Date`} selected={sortByRelevanceDate == "Date" ? true : false}>Latest</option>
                                                <option value={`Relevance`} selected={sortByRelevanceDate == "Relevance" ? true : false}>Relevance</option>
                                            </select> */}
                                        </span>
                                    }

                                </div>
                                <ArticleMainList articlesData={articlesData} hasMoreFinite={hasMoreFinite} OffsetPage={OffsetPage} handleSearch={handleSearch} isCommissioned={props?.match?.params?.searchByLatest == "commr" ? true : false} handleClearAllFilters={handleClearAllFilters} />
                            </div>
                        </div>

                    </div>
                </div>
            </div >
            <FooterSection commr={props.match.params.commr} />
        </>
    )
}

export default ArticleListPageNew